import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { validaSoloNumero, validaEmail } from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Dimmer } from "../spinner";
import CatalogoAgente from "../../catalogos/catalogoAgente";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoDependencias from "../../catalogos/catalogoDependencias";
import CatalogoPersonaWeb from "../../catalogos/catalogoPersonaWeb";

const ModalActualizarUsuario = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = localStorage.getItem("fechasistema");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();
  const txtIdDependencia = useRef();
  const txtDependencia = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrarDependencias, setMostrarDependencias] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [mostrar4, setMostrar4] = useState(false);
  const [contar, setContar] = useState(0);
  const [activate, setActivate] = useState(false);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [modulos, setModulos] = useState({
    minas: "0",
    _1x1000: "0",
    entes: "0",
    expendedores: "0",
    fiscalizacion: "0",
    configuracion: "0",
  });
  const [menumina, setMenuMina] = useState({
    declaraciones: "0",
    estadocuenta: "0",
    recibir: "0",
    enviar: "0",
    activar: "0",
    anular: "0",
    dispositivo: "0",
    servidor: "0",
  });

  const [menu1x1000, setMenu1x1000] = useState({
    retenciones: "0",
    estadocuenta1x1000: "0",
  });

  const [menuente, setMenuEnte] = useState({
    timbresente: "0",
    historicoente: "0",
  });

  const [menuexpendedor, setMenuExpendedor] = useState({
    timbresexpendedor: "0",
  });

  const [menufiscalizacion, setMenuFiscalizacion] = useState({
    fiscalret: "0",
    fiscalminas: "0",
    fiscalproduccion: "0",
    fiscal1x1000: "0",
    fiscalexpendedores: "0",
    fiscalgeneral: "0",
    fiscalverificacion: "0",
    fiscalgraficos: "0",
  });

  const [menuconfiguracion, setMenuConfiguracion] = useState({
    ute: "0",
    usuarioweb: "0",
    usuarioapp: "0",
    persona: "0",
  });

  const [ente, setEnte] = useState({
    mostrar: false,
    idagente: null,
    idtipoente: null,
  });

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);

  useEffect(() => {
    if (props.operacion) {
      setOperacion(props.operacion);
    }
  }, [props.operacion]);

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/usuarioapp/actualizarusuarioapp/${operacion}`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleCloseCatalogoAge = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoAge = (idAge, nomAge) => {
    setMostrar4(false);
    txtIdAgente.current.value = idAge;
    txtNombreAgente.current.value = nomAge;
    if (idAge !== "" && idAge !== null) {
      datosAgente(idAge);
    }
  };

  const handleAceptaCatalogoDependencias = (accion, values) => {
    setMostrarDependencias(false);
    if (accion === "aceptar") {
      txtIdDependencia.current.value = values.iddependencia;
      txtDependencia.current.value = values.nombre;
    }
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoAge = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const blanquear = () => {
    setActivate(false);
    setOperacionPer(0);
    setEnte({ mostrar: false, idagente: null, idtipoente: null });
    setModulos({
      minas: "0",
      _1x1000: "0",
      entes: "0",
      expendedores: "0",
      fiscalizacion: "0",
      configuracion: "0",
    });
  };

  const cancelar = () => {
    blanquear();

    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    setModulos({
      ...modulos,
      [event.target.name]: event.target.value === "true" ? "1" : "0",
    });
  };

  const onChangeMina = (e) => {
    setMenuMina({ ...menumina, [e.target.name]: e.target.checked ? "1" : "0" });
  };

  const onChange1x1000 = (e) => {
    setMenu1x1000({
      ...menu1x1000,
      [e.target.name]: e.target.checked ? "1" : "0",
    });
  };

  const onChangeEntes = (e) => {
    setMenuEnte({
      ...menuente,
      [e.target.name]: e.target.checked ? "1" : "0",
    });
  };

  const onChangeExpendedores = (e) => {
    setMenuExpendedor({
      ...menuexpendedor,
      [e.target.name]: e.target.checked ? "1" : "0",
    });
  };

  const onChangeFiscalizacion = (e) => {
    setMenuFiscalizacion({
      ...menufiscalizacion,
      [e.target.name]: e.target.checked ? "1" : "0",
    });
  };

  const onChangeConfiguracion = (e) => {
    setMenuConfiguracion({
      ...menuconfiguracion,
      [e.target.name]: e.target.checked ? "1" : "0",
    });
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreAgente.current.value = "";
        setEnte({
          mostrar: false,
          idagente: null,
          idtipoente: null,
        });
      }
    }
  };

  const validarDependencia = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosDependencia(event.target.value);
      } else {
        txtDependencia.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;

            setContar(contar + 1);
            setEnte({
              mostrar: response.data.ente,
              idagente: response.data.idagente,
              idtipoente: response.data.idtipoente,
            });
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setEnte({ mostrar: false, idagente: null, idtipoente: null });
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const datosDependencia = (id) => {
    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "iddependencia";
    let nomid2 = "tipoente";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${ente.idtipoente}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          if (response.data !== "") {
            txtDependencia.current.value = response.data.nombre;
          } else {
            txtDependencia.current.value = "";
            txtIdDependencia.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "la dependencia no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    var mensaje = "";
    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    } else if (ente.mostrar) {
      if (
        txtIdDependencia.current.value === "" ||
        txtDependencia.current.value === ""
      ) {
        mensaje = "debe seleccionar la dependencia";
        sigue = false;
        txtIdDependencia.current.focus();
      }
    }

    if (sigue) {
      let user = [];
      let datoPer = [];

      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        idagente: txtIdAgente.current.value,
        iddependencia: txtIdDependencia.current.value,
        accaplicaciones:
          modulos.minas +
          modulos._1x1000 +
          modulos.entes +
          modulos.expendedores +
          modulos.fiscalizacion +
          modulos.configuracion,
        menumina:
          menumina.declaraciones +
          menumina.estadocuenta +
          menumina.recibir +
          menumina.enviar +
          menumina.activar +
          menumina.anular +
          menumina.dispositivo +
          menumina.servidor,
        menu1x1000: menu1x1000.retenciones + menu1x1000.estadocuenta1x1000,
        menuente: menuente.timbresente + menuente.historicoente,
        menuexpendedor: menuexpendedor.timbresexpendedor,
        menufiscalizacion:
          menufiscalizacion.fiscalret +
          menufiscalizacion.fiscalminas +
          menufiscalizacion.fiscalproduccion +
          menufiscalizacion.fiscal1x1000 +
          menufiscalizacion.fiscalexpendedores +
          menufiscalizacion.fiscalgeneral +
          menufiscalizacion.fiscalverificacion +
          menufiscalizacion.fiscalgraficos,
        menuconfiguracion:
          menuconfiguracion.ute +
          menuconfiguracion.usuarioweb +
          menuconfiguracion.usuarioapp +
          menuconfiguracion.persona,
      });

      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });

      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        setTabIndex(0);
        setTabIndex1(0);
        if (props.usuario) {
          if (props.usuario.iddependencia !== null) {
            setEnte({
              mostrar: true,
              idagente: props.usuario.idagente,
              idtipoente: props.usuario.idtipoente,
            });
          }
          setOperacionPer(0);
          setModulos({
            minas: props.usuario.accaplicaciones.toString().substring(0, 1),
            _1x1000: props.usuario.accaplicaciones.toString().substring(1, 2),
            entes: props.usuario.accaplicaciones.toString().substring(2, 3),
            expendedores: props.usuario.accaplicaciones
              .toString()
              .substring(3, 4),
            fiscalizacion: props.usuario.accaplicaciones
              .toString()
              .substring(4, 5),
            configuracion: props.usuario.accaplicaciones
              .toString()
              .substring(5, 6),
          });

          setMenuMina({
            declaraciones: props.usuario.menumina.toString().substring(0, 1),
            estadocuenta: props.usuario.menumina.toString().substring(1, 2),
            recibir: props.usuario.menumina.toString().substring(2, 3),
            enviar: props.usuario.menumina.toString().substring(3, 4),
            activar: props.usuario.menumina.toString().substring(4, 5),
            anular: props.usuario.menumina.toString().substring(5, 6),
            dispositivo: props.usuario.menumina.toString().substring(6, 7),
            servidor: props.usuario.menumina.toString().substring(7, 8),
          });

          setMenu1x1000({
            retenciones: props.usuario.menu1x1000.toString().substring(0, 1),
            estadocuenta1x1000: props.usuario.menu1x1000
              .toString()
              .substring(1, 2),
          });

          setMenuEnte({
            timbresente: props.usuario.menuente.toString().substring(0, 1),
            historicoente: props.usuario.menuente.toString().substring(1, 2),
          });

          setMenuExpendedor({
            timbresexpendedor: props.usuario.menuexpendedor
              .toString()
              .substring(0, 1),
          });

          setMenuFiscalizacion({
            fiscalret: props.usuario.menufiscalizacion
              .toString()
              .substring(0, 1),
            fiscalminas: props.usuario.menufiscalizacion
              .toString()
              .substring(1, 2),
            fiscalproduccion: props.usuario.menufiscalizacion
              .toString()
              .substring(2, 3),
            fiscal1x1000: props.usuario.menufiscalizacion
              .toString()
              .substring(3, 4),
            fiscalexpendedores: props.usuario.menufiscalizacion
              .toString()
              .substring(4, 5),
            fiscalgeneral: props.usuario.menufiscalizacion
              .toString()
              .substring(5, 6),
            fiscalverificacion: props.usuario.menufiscalizacion
              .toString()
              .substring(6, 7),
            fiscalgraficos: props.usuario.menufiscalizacion
              .toString()
              .substring(7, 8),
          });

          setMenuConfiguracion({
            ute: props.usuario.menuconfiguracion.toString().substring(0, 1),
            usuarioweb: props.usuario.menuconfiguracion
              .toString()
              .substring(1, 2),
            usuarioapp: props.usuario.menuconfiguracion
              .toString()
              .substring(2, 3),
            persona: props.usuario.menuconfiguracion.toString().substring(3, 4),
          });
        } else {
          setModulos({
            minas: "0",
            _1x1000: "0",
            entes: "0",
            expendedores: "0",
            fiscalizacion: "0",
            configuracion: "0",
          });

          setMenuMina({
            declaraciones: "0",
            estadocuenta: "0",
            recibir: "0",
            enviar: "0",
            activar: "0",
            anular: "0",
            dispositivo: "0",
            servidor: "0",
          });

          setMenu1x1000({
            retenciones: "0",
            estadocuenta1x1000: "0",
          });

          setMenuEnte({
            timbresente: "0",
            historicoente: "0",
          });

          setMenuExpendedor({
            timbresexpendedor: "0",
          });

          setMenuFiscalizacion({
            fiscalret: "0",
            fiscalminas: "0",
            fiscalproduccion: "0",
            fiscal1x1000: "0",
            fiscalexpendedores: "0",
            fiscalgeneral: "0",
            fiscalverificacion: "0",
            fiscalgraficos: "0",
          });

          setMenuConfiguracion({
            ute: "0",
            usuarioweb: "0",
            usuarioapp: "0",
            persona: "0",
          });
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
              ? "Modificar Usurario"
              : operacion === 3
              ? "Eliminar Usuario"
              : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CatalogoPersonaWeb
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <CatalogoAgente
          show={mostrar4}
          onHideCancelaCatAge={handleCloseCatalogoAge}
          onHideAceptaCatAge={handleAceptaCatalogoAge}
        />
        <CatalogoDependencias
          show={mostrarDependencias}
          ente={ente}
          onHide={handleAceptaCatalogoDependencias}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="">
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active "
                  style={{ backgroundColor: "#25d366" }}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#tab-1"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                  Aplicaciones
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : "51"}
                    >
                      <option value="51">Activo</option>
                      <option value="52">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">Agente</legend>

                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Código
                        Agente:
                      </label>
                      <input
                        type="text"
                        disabled={deshabilitado}
                        autoComplete="off"
                        ref={txtIdAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputIdAgente"
                        defaultValue={
                          props.usuario ? props.usuario.idagente : ""
                        }
                        onKeyUp={validarAgente}
                        onBlur={validarAgente}
                      />
                      <button
                        disabled={deshabilitado}
                        onClick={catalogoAge}
                        className="btn btn-sm  btn-success"
                      >
                        <i
                          disabled={deshabilitado}
                          className="fa fa-search"
                        ></i>{" "}
                      </button>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={true}
                        autoComplete="off"
                        ref={txtNombreAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario"
                        defaultValue={
                          props.usuario ? props.usuario.nombreagente.trim() : ""
                        }
                      />
                    </div>
                  </fieldset>

                  <fieldset
                    className="row border-azul rounded mx-auto"
                    style={{
                      visibility: ente.mostrar ? "visible" : "collapse",
                    }}
                  >
                    <legend className="float-none m-0 w-auto">
                      Dependencia
                    </legend>

                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Código
                        Dep.:
                      </label>
                      <input
                        type="text"
                        disabled={deshabilitado}
                        autoComplete="off"
                        ref={txtIdDependencia}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="iddependencia"
                        defaultValue={
                          props.usuario ? props.usuario.iddependencia : ""
                        }
                        onKeyUp={validarDependencia}
                        onBlur={validarDependencia}
                      />
                      <button
                        disabled={deshabilitado}
                        onClick={() => setMostrarDependencias(true)}
                        className="btn btn-sm  btn-success"
                      >
                        <i
                          disabled={deshabilitado}
                          className="fa fa-search"
                        ></i>{" "}
                      </button>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={true}
                        autoComplete="off"
                        ref={txtDependencia}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="dependencia"
                        defaultValue={
                          props.usuario ? props.usuario.dependencia : ""
                        }
                      />
                    </div>
                  </fieldset>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          autoComplete="off"
                          ref={txtCedula}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCedula"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.cedula
                              : ""
                          }
                          onKeyUp={validarPersona}
                          onBlur={validarPersona}
                        />
                        <button
                          disabled={deshabilitado}
                          onClick={catalogoPer}
                          className="btn btn-sm  btn-success"
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-search"
                          ></i>{" "}
                        </button>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-3 mx-auto px-2">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                          Nacionalidad:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbNacionalidad}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nacionalidad
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example col-md-"
                        >
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-2 ml-auto px-1">
                        <label
                          className="input-group-text ml-2"
                          id="inputGroup-sizing-sm"
                        >
                          Sexo:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbSexo}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.sexo
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtNombreUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nombres.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          apellidos:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtApellidoUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.apellidos.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Direccion:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtDireccionUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.direccion.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-calendar-alt"></i>
                          Fecha Nacimiento:
                        </label>
                        <input
                          type="date"
                          disabled={!habilitadoNU}
                          ref={txtFechaNac}
                          className="form-control px-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputFechaNac"
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          defaultValue={
                            props.datospersonales
                              ? moment(
                                  props.datospersonales.fnacimiento
                                ).format("YYYY-MM-DD")
                              : ""
                          }
                          onKeyUp={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtTlfUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputTlfUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf1 !== null
                                ? props.datospersonales.tlf1.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-mobile-alt"></i>
                          Celular:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtCelUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCelUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf2 !== null
                                ? props.datospersonales.tlf2.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          {" "}
                          <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          autoComplete="off"
                          ref={txtEmailUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputEmailUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.correoe !== null
                                ? props.datospersonales.correoe.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  {/* Minas*/}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Minas
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="minas"
                            disabled={deshabilitado}
                            id="minas"
                            value={true}
                            checked={modulos.minas === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="minas">
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="minas"
                            disabled={deshabilitado}
                            id="minas2"
                            value={false}
                            checked={modulos.minas === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="minas2">
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos.minas === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="declaraciones"
                                name="declaraciones"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.declaraciones === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="declaraciones"
                              >
                                Declaraciones
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="estadocuenta"
                                name="estadocuenta"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.estadocuenta === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="estadocuenta"
                              >
                                Estado Cuenta
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="recibir"
                                name="recibir"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.recibir === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="recibir"
                              >
                                Recibir
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="enviar"
                                name="enviar"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.enviar === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="enviar"
                              >
                                Enviar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="activar"
                                name="activar"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.activar === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="activar"
                              >
                                Activar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="anular"
                                name="anular"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.anular === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="anular"
                              >
                                Anular
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="dispositivo"
                                name="dispositivo"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.dispositivo === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="dispositivo"
                              >
                                Dispositivo
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="servidor"
                                name="servidor"
                                onChange={onChangeMina}
                                defaultChecked={
                                  menumina.servidor === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="servidor"
                              >
                                Servidor
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>

                  {/* 1x1000*/}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        1x1000
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="_1x1000"
                            disabled={deshabilitado}
                            id="_1x1000"
                            value={true}
                            checked={modulos._1x1000 === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="_1x1000">
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="_1x1000"
                            disabled={deshabilitado}
                            id="_1x10002"
                            value={false}
                            checked={modulos._1x1000 === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="_1x10002">
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos._1x1000 === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="retenciones"
                                name="retenciones"
                                onChange={onChange1x1000}
                                defaultChecked={
                                  menu1x1000.retenciones === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="retenciones"
                              >
                                Retenciones
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="estadocuenta1x1000"
                                name="estadocuenta1x1000"
                                onChange={onChange1x1000}
                                defaultChecked={
                                  menu1x1000.estadocuenta1x1000 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="estadocuenta1x1000"
                              >
                                Estado Cuenta 1x1000
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>

                  {/* Entes*/}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Entes
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="entes"
                            disabled={deshabilitado}
                            id="entes"
                            value={true}
                            checked={modulos.entes === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="entes">
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="entes"
                            disabled={deshabilitado}
                            id="entes2"
                            value={false}
                            checked={modulos.entes === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label className="form-check-label" for="entes2">
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos.entes === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="timbresente"
                                name="timbresente"
                                onChange={onChangeEntes}
                                defaultChecked={
                                  menuente.timbresente === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="timbresente"
                              >
                                Timbre Fiscal
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="historicoente"
                                name="historicoente"
                                onChange={onChangeEntes}
                                defaultChecked={
                                  menuente.historicoente === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="historicoente"
                              >
                                Historico
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>

                  {/* Expendedores */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Expendedores
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="expendedores"
                            disabled={deshabilitado}
                            id="expendedores"
                            value={true}
                            checked={modulos.expendedores === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="expendedores"
                          >
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="expendedores"
                            disabled={deshabilitado}
                            id="expendedores2"
                            value={false}
                            checked={modulos.expendedores === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="expendedores2"
                          >
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos.expendedores === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="timbresexpendedor"
                                name="timbresexpendedor"
                                onChange={onChangeExpendedores}
                                defaultChecked={
                                  menuexpendedor.timbresexpendedor === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="timbresexpendedor"
                              >
                                Timbre Fiscal
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>

                  {/* Fiscalizacion */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Fiscalización
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="fiscalizacion"
                            disabled={deshabilitado}
                            id="fiscalizacion"
                            value={true}
                            checked={modulos.fiscalizacion === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="fiscalizacion"
                          >
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="fiscalizacion"
                            disabled={deshabilitado}
                            id="fiscalizacion2"
                            value={false}
                            checked={modulos.fiscalizacion === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="fiscalizacion2"
                          >
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos.fiscalizacion === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalret"
                                name="fiscalret"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalret === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalret"
                              >
                                R.E.T
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalminas"
                                name="fiscalminas"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalminas === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalminas"
                              >
                                Minas
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalproduccion"
                                name="fiscalproduccion"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalproduccion === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalproduccion"
                              >
                                Producción
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscal1x1000"
                                name="fiscal1x1000"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscal1x1000 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscal1x1000"
                              >
                                1X1000
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalexpendedores"
                                name="fiscalexpendedores"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalexpendedores === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalexpendedores"
                              >
                                Expendedores
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalgeneral"
                                name="fiscalgeneral"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalgeneral === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalgeneral"
                              >
                                Deuda General
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalverificacion"
                                name="fiscalverificacion"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalverificacion === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalverificacion"
                              >
                                Verificacion
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="fiscalgraficos"
                                name="fiscalgraficos"
                                onChange={onChangeFiscalizacion}
                                defaultChecked={
                                  menufiscalizacion.fiscalgraficos === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="fiscalgraficos"
                              >
                                Graficos Ingresos
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>

                  {/* Configuracion */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Configuración
                      </legend>
                      <div className="input-group col-sm-12 w-100">
                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="configuracion"
                            disabled={deshabilitado}
                            id="configuracion"
                            value={true}
                            checked={modulos.configuracion === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="configuracion"
                          >
                            Disponible
                          </label>
                        </div>

                        <div className="form-check col px-3 form-check-inline px-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="configuracion"
                            disabled={deshabilitado}
                            id="configuracion2"
                            value={false}
                            checked={modulos.configuracion === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            for="configuracion2"
                          >
                            No Disponible
                          </label>
                        </div>
                        <div />
                      </div>
                      {modulos.configuracion === "1" && (
                        <div className="col-md-12 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="ute"
                                name="ute"
                                onChange={onChangeConfiguracion}
                                defaultChecked={
                                  menuconfiguracion.ute === "1" ? true : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="ute"
                              >
                                U.T.E
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="usuarioweb"
                                name="usuarioweb"
                                onChange={onChangeConfiguracion}
                                defaultChecked={
                                  menuconfiguracion.usuarioweb === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="usuarioweb"
                              >
                                Usuario Web
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="usuarioapp"
                                name="usuarioapp"
                                onChange={onChangeConfiguracion}
                                defaultChecked={
                                  menuconfiguracion.usuarioapp === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="usuarioapp"
                              >
                                Usuario App
                              </label>
                            </div>
                          </div>

                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="persona"
                                name="persona"
                                onChange={onChangeConfiguracion}
                                defaultChecked={
                                  menuconfiguracion.persona === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="persona"
                              >
                                Personas
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActualizarUsuario;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarUsuarioApp.js